import React from 'react';
import ReactDOM from 'react-dom';
import SMRoomUnavailabilityResource from 'resources/SMRoomUnavailabilityResource';
import SMORoomUnavailabilityCalendarBaloon from 'components/dashboard/calendar/SMORoomUnavailabilityCalendarBaloon';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMORoomUnavailabilityListView extends React.Component {
  
  itemDidClick(item, e) {
    e.preventDefault();
    e.persist();
    const baloon = <SMORoomUnavailabilityCalendarBaloon
      item={item}
      clientX={e.clientX}
      clientY={e.clientY}
      room={this.props.room}
      plan={this.props.plan}
      delegate={this.props.delegate} />;
    
    ReactDOM.render(baloon, document.getElementById('js-baloon-container'));
  }

  deleteItemDidClick(itemId, e) {
    e.preventDefault();
    e.persist();
    const responseHandler = (data, error, xhr)=>{
      if (xhr.status == 204) {
        this.props.delegate.formDidUpdate(e);
      }
    };
        
    SMRoomUnavailabilityResource.deleteUnavailability(itemId, {
        room_id: this.props.room.id,
    }, responseHandler);
  }

  render() {
    let rows = [];
    for (let i=0; i < this.props.plan.unavailabilities.length; i++) {
      var unavailability = this.props.plan.unavailabilities[i];
          
      rows.push(
        <div key={unavailability.id} className='special-price-list__box'>
          <a href="#" onClick={this.itemDidClick.bind(this, unavailability)} className="w450 dib">{SMFormatHelper.unavailabilityText(unavailability, 'list')}</a>
          <a href="#" onClick={this.deleteItemDidClick.bind(this, unavailability.id)} className="fr"><i className="fa fa-times"></i> 削除</a>
        </div>
      );
    }
    
    return(
      <div className="special-price-list">
        {rows}
      </div>
    );
  }
}

export default SMORoomUnavailabilityListView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomUnavailabilityListView.jsx